import { BaseEntity } from './base-entity';
import { ContactMethod } from './contact-method';
import { ContactDistributionType } from './contact-distribution-type';

export class ContactType extends BaseEntity {
  mappedName: string;
  contactMethod: ContactMethod;
  distributionType: ContactDistributionType;
}
